import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m1.75 3.75 3.16 2.395m0 0C3.727 7.23 2.803 8.44 2.268 9.21c-.172.247-.258.37-.302.55a1.136 1.136 0 0 0 0 .48c.044.18.13.303.302.55 1.169 1.68 4.19 5.46 7.733 5.46 1.92 0 3.687-1.11 5.09-2.395M4.91 6.145 8.207 8.64m6.883 5.214 3.161 2.395m-3.16-2.395-3.296-2.496M8.206 8.64a2.25 2.25 0 0 0 3.587 2.718M8.207 8.64l3.588 2.718m-3.86-7.197A5.655 5.655 0 0 1 10 3.75c3.543 0 6.564 3.78 7.733 5.46.172.247.258.37.302.55.034.138.034.342 0 .48-.044.18-.13.303-.302.55-.108.155-.232.329-.37.515"
	})]
});
const ForwardRef = forwardRef(SvgEyeOff);
export { ForwardRef as ReactComponent };
